export class ModelStateFields {
  static readonly selectedModel = 'selectedModel';
  static readonly selectedSnapshot = 'selectedSnapshot';
}
